import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Notus_logo.png'


_pushScopeId("data-v-403af92a")
const _hoisted_1 = {
  key: 0,
  class: "header-back d-lg-none cursor-pointer"
}
const _hoisted_2 = { class: "header-logo" }
const _hoisted_3 = {
  href: "https://notus.pl/",
  target: "_blank"
}
const _hoisted_4 = ["alt"]
const _hoisted_5 = {
  key: 1,
  class: "header-logo"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1)
const _hoisted_8 = {
  key: 2,
  class: "header-lang__switch"
}
const _hoisted_9 = { class: "header-close" }
const _hoisted_10 = { class: "d-none d-lg-block" }
const _hoisted_11 = { class: "d-block d-lg-none" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notus_svg_icon = _resolveComponent("notus-svg-icon")!
  const _component_notus_lang_switcher = _resolveComponent("notus-lang-switcher")!
  const _component_notus_link = _resolveComponent("notus-link")!
  const _component_NotusConfirmModal = _resolveComponent("NotusConfirmModal")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {'no-bg': _ctx.noBg}])
  }, [
    (_ctx.showBackButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_notus_svg_icon, {
            "icon-type": "arrow_back_muted",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBackClicked()))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('general.header.logo.alt'),
          class: "logo mb-auto mt-1"
        }, null, 8, _hoisted_4)
      ])
    ]),
    (_ctx.partnerLogoUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.partnerLogoUrl,
            alt: "{{ $t('general.header.partner-logo.alt')}}",
            class: "logo"
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    _hoisted_7,
    (!_ctx.i18nHidden)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_notus_lang_switcher)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_notus_link, { onClick: _ctx.onCloseHandler }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(_ctx.copyBackButton)), 1),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_notus_svg_icon, { "icon-type": "close_muted" })
          ])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_NotusConfirmModal, {
            key: 0,
            config: _ctx.notusConfirmModalConfig,
            onOnChoose: _ctx.onConfirmModal
          }, null, 8, ["config", "onOnChoose"]))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}